const flaggedContentPT = {
    "view": {
        "form": {
            "button": {
                "viewDetails": "Ver Detalhes"
            },
            "message": {
                "releaseHasBeenAddedToWhitelist": "Lançamento <strong>{{releaseName}}</strong> foi adicionado à lista branca.",
                "releaseHasFlaggedContent": "Lançamento <strong>{{releaseName}}</strong> contém faixas sinalizadas. Uma taxa de <strong>15 €</strong> por faixa sinalizada aplica-se para entregá-la ao <strong>Spotify</strong>.<br/><br/> Clique no botão abaixo para completar seu pagamento e continuar."
            },
            "modal": {
                "header": {
                    "titleFlaggedTracksDetails": "Detalhes das Faixas Sinalizadas",
                    "titleFlaggedTrackPayment": "Pagamento de Lista Branca do Spotify"
                },
                "body": {
                    "table": {
                        "title": "As seguintes faixas foram sinalizadas. Por favor, reveja os detalhes abaixo:",
                        "column": {
                            "name": "Nome da Faixa",
                            "flaggedArtist": "Artista Sinalizado",
                            "payableAmount": "Valor a Pagar",
                            "paymentStatus": "Status do Pagamento"
                        },
                        "label": {
                            "payableAmount": "15 €",
                            "paid": "PAGO",
                            "pending": "PENDENTE",
                        },
                    },
                    "label": {
                        "processingPayment": "Processando Pagamento...",
                        "paymentSuccessful": "Pagamento Bem-sucedido!",
                        "paymentFailed": "Pagamento Falhou!"
                    },
                    "message": {
                        "totalPayableAmount": "Para completar a entrega do seu lançamento ao <strong>Spotify</strong>, é necessário um depósito reembolsável de <strong>{{totalAmount}} €</strong>. Por favor, aceite os termos abaixo e clique no botão <strong>Prosseguir</strong> para fazer seu pagamento.",
                        "escrowAmountAgreement": "Aceito e reconheço que um valor em depósito de <strong>{{totalAmount}} €</strong> será depositado por mim. Este valor será mantido até o <strong>fim da assinatura</strong> e, desde que não surjam problemas, será devolvido a mim no final deste período. No entanto, se eu violar os termos deste acordo durante este tempo, o valor em depósito será aplicado à fatura pendente e não será reembolsado. Ao prosseguir, afirmo meu entendimento e aceitação destas condições.",
                        "escrowPaymentRejected": "Não aceito os termos de pagamento em depósito e, consequentemente, reconheço que meu lançamento <strong>{{releaseName}}</strong> <strong>não será distribuído ao Spotify</strong>.",
                        "consentRecordedSuccessfully": "Consentimento Registrado com Sucesso!"
                    }
                },
                "button": {
                    "proceed": "Prosseguir"
                }
            }
        }
    }
}

export default flaggedContentPT;